import { Mention } from './Mention';

export enum ChatMessageStatus {
  Pending = 'pending',
  Delivered = 'delivered',
  Deleted = 'deleted',
}

export interface ChatMessage {
  propertyId: string;
  createdAt: number;
  messageId: string;
  userId: string;
  content: string;
  status: ChatMessageStatus;
  senderName: string;
  senderRole: string; // 'Owner' | 'Editor' | 'Viewer'
  mentions?: Mention[];
  reactions?: { userId: string; emoji: string; userName: string }[];
  edited?: boolean;
  editedAt?: number;
  clientMessageId?: string;
}
